import React from 'react';
import { connect } from 'react-redux';

import { Row, Col, Button, FormGroup, Label } from 'reactstrap';
import LoadingSpinner from 'cyder/loadingSpinner/LoadingSpinner';

import { uploadCertificate } from 'actions/admin/misc/resources/action.js';

import { SGBC_S3_ROOT_CERTIFICATE } from 'config';
const axios = require('axios').default;
const FormData = require('form-data');

class CyderCertificate extends React.Component {
    constructor(props) {
        super(props);
        this._isMounted = true;
        this.fileInput = React.createRef();
        this.upload = this.upload.bind(this);
        this.showLoading = this.showLoading.bind(this);
        this.state = {
            loading: false,
            attachmentId: '',
            filename: '',
            message: '',
            file: {},
            virusMessage: '',
            scanning: false,
            certDetails: {},
        };
    }
    showLoading(loading) {
        if (!this._ismounted) return;
        this.setstate({
            loading,
        });
    }
    componentWillUnmount() {
        this._isMounted = false;
    }
    async componentDidMount() {
        this.showLoading(true);
        let attachmentId = this.props.attachmentId;
        if (attachmentId !== undefined) {
            // let attachmentDetails = await this.props.load(attachmentId);
            let filename = this.props.filename;
            if (this._isMounted)
                this.setState({
                    attachmentId: attachmentId === 'null' ? null : attachmentId,
                    message: this.props.message || '',
                    filename,
                    loading: false,
                    certDetails: this.props.certDetails || {},
                });
        }
    }
    componentDidUpdate() {
        if (
            this.state.attachmentId !== null &&
            this.state.attachmentId !== '' &&
            this.state.attachmentId !== this.props.attachmentId &&
            this.state.certDetails !== undefined &&
            this.state.certDetails !== null
        ) {
            this.setState({
                attachmentId: this.props.attachmentId,
                filename: this.props.filename,
                certDetails: this.props.certDetails,
            });
        }
    }
    handleFileInputChange = event => {
        this.setState({ scanning: true });
        const limit = this.props.sizeLimit || 5;
        const reader = new FileReader();
        let file = event.target.files[0];

        let _fn = `${this.state.certDetails.id}-${this.state.certDetails.certificateNumber}`;

        const files = Array.from(event.target.files).map((x, index) => {
            // Rename the file before upload (e.g., prefixing with timestamp)
            const newFileName = `${_fn}-MN`;
            return new File([x], newFileName, { type: x.type });
        });

        // const files = Array.from(event.target.files);
        // Virus Scanning
        const uploaders = files.map(x => {
            const formData = new FormData();
            formData.append('file', x);

            return axios.post('https://av.sgbc.online/api/av', formData, {
                headers: { 'Content-Type': 'multipart/form-dta' },
            });
        });

        console.log('Scanning files before uploading.');

        axios
            .all(uploaders)
            .then(res => {
                console.log('Files are all clean.');
                this.setState({
                    virusMessage: '',
                    scanning: false,
                });

                reader.onload = () => {
                    const newFileName = `${this.state.certDetails.id}-${this.state.certDetails.certificateNumber}-MN`;
                    const newFile = new File([file], newFileName, { type: file.type });

                    newFile.base64 = reader.result; // Store base64 data

                    if (newFile && newFile.size > limit * 1000000) {
                        this.setState({
                            file: null,
                            message: `File size should not be more than ${limit} MB`,
                        });
                        return;
                    }

                    console.log('newFile', newFile);

                    this.setState({ file: newFile, message: '' }, () => this.upload());
                };
                // Handle cancel
                if (file.length !== 0) reader.readAsDataURL(file);
            })
            .catch(err => {
                const { viruses } = err.response.data;
                this.setState({
                    virusMessage: viruses,
                    scanning: false,
                });
            });
    };
    upload() {
        this.showLoading(true);
        var base64 = this.state.file.base64;
        var idx = base64.indexOf(`base64,`);
        base64 = base64.substr(idx + 7);
        var certId = this.state.certDetails.id;

        var data = {
            attachment: base64,
            contenttype: this.state.file.type,
            filename: this.state.file.name,
            filesize: 1000,
            certId: certId,
        };
        this.props
            .upload(data)
            .then(res => {
                this.props.onUploadSuccess(res.data);
                this.showLoading(false);
                this.setState({
                    attachmentId: res.data.id,
                    filename: res.data.filename,
                });
            })
            .catch(error => {
                this.props.onUploadFail(error);
                this.showLoading(false);
                throw error;
            });
    }
    render() {
        if (this.state.loading || this.state.scanning)
            return (
                <div style={{ width: this.state.scanning ? '200px' : '20px' }}>
                    <LoadingSpinner text={this.state.scanning ? 'Virus Scanning ...' : null} />
                </div>
            );
        const { virusMessage } = this.state;
        return (
            <div>
                {!this.state.attachmentId && (
                    <div style={{ marginLeft: '10px', alignSelf: 'baseline' }}>
                        <Row>
                            <Col>
                                <FormGroup className="upload-section">
                                    {this.state.message !== null && this.state.message !== '' && (
                                        <React.Fragment>
                                            <small htmlFor="resource">{this.state.message}</small>
                                            <br />
                                            <br />
                                        </React.Fragment>
                                    )}
                                    <Button
                                        className="primary-btn-style text-bold text-capitalize mr-1"
                                        onClick={() => this.fileInput.current.click()}
                                    >
                                        Choose File and Upload
                                    </Button>
                                    &nbsp;
                                    <Label for="resource">{this.state.attachmentId ? this.state.filename : ''}</Label>
                                    <input
                                        type="file"
                                        ref={this.fileInput}
                                        disabled={this.state.loading}
                                        onChange={this.handleFileInputChange}
                                        style={{ display: 'none' }}
                                    />
                                    <div style={{ width: '150px', marginTop: '0px' }}>
                                        <span>
                                            Maximum file size is {this.props.sizeLimit || 5}
                                            MB
                                        </span>
                                    </div>
                                    {virusMessage && (
                                        <p
                                            style={{ color: 'red' }}
                                            className="mt-2 form-text"
                                        >{`[Unable to upload] Virus scan found '${virusMessage}' in one of the files.`}</p>
                                    )}
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                )}
                {this.state.attachmentId && (
                    <div style={{ marginLeft: '15px', alignSelf: 'baseline' }}>
                        <a style={{ color: 'dark grey' }} target="blank" href={`${SGBC_S3_ROOT_CERTIFICATE}${this.state.attachmentId}`}>
                            <u>{this.state.filename}</u>
                        </a>
                        &nbsp;
                        <i
                            className="material-icons"
                            style={{ cursor: 'pointer' }}
                            onClick={e => {
                                this.setState({
                                    attachmentId: '',
                                });
                            }}
                        >
                            edit
                        </i>
                        &nbsp;
                        {this.props.removeFile && (
                            <i
                                className="material-icons"
                                style={{ cursor: 'pointer' }}
                                onClick={e => {
                                    this.props.removeFile(this.props.attachment);
                                    this.setState({ attachmentId: '' });
                                }}
                            >
                                delete
                            </i>
                        )}
                    </div>
                )}
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {};
};
const mapDispatchToProps = dispatch => {
    return {
        upload: data => {
            return dispatch(uploadCertificate(data));
        },
        // load: id => {
        //     return dispatch(loadCertificate(id));
        // },
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(CyderCertificate);
